const LOAD_DETAIL_LANGUAGE_SKILLS           = 'LOAD_DETAIL_LANGUAGE_SKILLS'
const LOAD_DETAIL_LANGUAGE_SKILLS_SUCCESS   = 'LOAD_DETAIL_LANGUAGE_SKILLS_SUCCESS'
const LOAD_DETAIL_LANGUAGE_SKILLS_FAILED    = 'LOAD_DETAIL_LANGUAGE_SKILLS_FAILED'
const UNMOUNT_DETAIL_LANGUAGE_SKILLS        = 'UNMOUNT_DETAIL_LANGUAGE_SKILLS'

const initialState = {
  loading: true,
  data: null,
  message: null,
}

const languageSkillsDetailReducer = (state = initialState, action) => {
  switch(action.type){
    case LOAD_DETAIL_LANGUAGE_SKILLS:
      return{
        ...state,
        data: null,
        loading: true,
      }
    case LOAD_DETAIL_LANGUAGE_SKILLS_SUCCESS:
      return{ 
        ...state, 
        data: action.payload.data,
        loading: false,
        message: 'SUCCESS'
      }
    case LOAD_DETAIL_LANGUAGE_SKILLS_FAILED:
      return{ 
        ...state, 
        data: null,
        loading: true,
        message: 'FAILED'
      }
      case UNMOUNT_DETAIL_LANGUAGE_SKILLS:
        return{ 
          ...state, 
          data: null,
          loading: true,
        }
    default:
      return state
  }


}

export default languageSkillsDetailReducer;